import React from "react";
import { useNavigate } from "react-router-dom";
import { createRole } from "adminApi/RoleManageApi/RoleManage";
import { validateForm } from "utils/validation";
import { RoleRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddRoleForm from "./Componates/AddRoleForm";
import fields from "../json/RoleLisrFeilds.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const RoleAdd = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors } = useFormChange(initialValues, RoleRules);

  // Form submit hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      return await createRole({ data: formValues });          
    },
    (vals) => {
      const err = validateForm(vals, RoleRules)
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Role created successfully"
  );

  return (
    <>
      {(loadingSubmit) && <Spinner isSpinner={true} />}
      <AddRoleForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Create Role"
      />
    </>
  );
};

export default RoleAdd;
